'use client'

import { memo } from 'react'
import { Input } from '@/components/ui/input'
import { Eye, EyeOff } from 'lucide-react'

interface PasswordInputProps {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  show: boolean
  onToggleShow: () => void
  placeholder: string
  autoComplete: string
  id: string
}

/**
 * Password field with a show/hide toggle (D7-06).
 * Shared by auth-modal and session-expired-modal.
 */
export const PasswordInput = memo(({ value, onChange, show, onToggleShow, placeholder, autoComplete, id }: PasswordInputProps) => (
  <div className="relative">
    <Input
      type={show ? 'text' : 'password'}
      name={id}
      id={id}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      required
      autoComplete={autoComplete}
      className="h-11 px-4 pr-12 rounded-xl border-gray-200 dark:border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 dark:focus:ring-indigo-800 transition-all duration-200 dark:bg-gray-800 dark:text-gray-100"
    />
    <button
      type="button"
      onClick={onToggleShow}
      className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300 transition-colors"
      tabIndex={-1}
    >
      {show ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
    </button>
  </div>
))

PasswordInput.displayName = 'PasswordInput'
